import script from "./Notification.vue?vue&type=script&setup=true&lang=js"
export * from "./Notification.vue?vue&type=script&setup=true&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=e719060a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e719060a"]])

export default __exports__